<template>
  <div class="check">
    <h1>投稿内容チェック</h1>
    <div v-if="isMovie">
      <video :src="mediaSrc" autoplay></video>
    </div>
    <div v-else>
      <img :src="mediaSrc" />
    </div>
    <div style="display: block; margin-top: 30px;">
      <input type="radio" id="gourmet" v-model="radio" value="gourmet">
      <label for="gourmet">料理</label>
      <input type="radio" id="inside" v-model="radio" value="inside">
      <label for="inside">内観</label>
      <input type="radio" id="outside" v-model="radio" value="outside">
      <label for="outside">外観</label>
      <input type="radio" id="menu" v-model="radio" value="menu">
      <label for="menu">メニュー</label>
      <input type="radio" id="other" v-model="radio" value="other">
      <label for="other">その他</label>
    </div>
    <button style="margin-top: 30px; padding: 10px;" @click="submit">登録</button>
    <button style="margin-top: 30px; margin-left: 30px; background-color:red; padding: 10px;" @click="deleteData">削除</button>
  </div>
</template>

<script>
import { firestore, storage } from '../firebase/firestore'
const medias = firestore.collection('medias')
const posts = firestore.collection('posts')
export default {
  name: 'check',
  data () {
    return {
      isMovie: false,
      mediaSrc: '',
      radio: 'gourmet',
      mediasId: [],
      postsData: [],
      postIdsArray: [],
      postUrlsArray: [],
      postId: '',
      uid: '',
      fileName: ''
    }
  },
  mounted () {
    let isLogin = localStorage.getItem('login')
    if (!isLogin) {
      this.$router.push('/gourmet/check-login')
    }
    this.getData().then(() => {
      posts.onSnapshot(querySnapshot => {
        querySnapshot.forEach(data => {
          this.postsData.push({
            'id': data.id,
            'mediaIds': data.data().mediaIds,
            'mediaUrls': data.data().mediaUrls
          })
        })
      })
    })
  },
  methods: {
    getData () {
      // データ格納
      return new Promise((resolve) => {
        medias.onSnapshot(querySnapshot => {
          querySnapshot.forEach(data => {
            if (data.data().genre === '') {
              this.mediasId.push(data.id)
            }
          })
          medias.doc(this.mediasId[0]).get().then((doc) => {
            console.log(this.mediasId[0])
            this.postId = doc.data().post_id
            this.uid = doc.data().firebase_uid
            this.fileName = doc.data().file_name
            console.log(this.fileName)
            if (doc.data().media_type === 'images') {
              this.isMovie = false
              this.mediaSrc = doc.data().media_url
            } else {
              this.isMovie = true
              this.mediaSrc = doc.data().media_url
            }
            console.log(this.mediaSrc)
          })
        })
        resolve()
      })
    },
    submit () {
      medias.doc(this.mediasId[0]).update({
        genre: this.radio
      }).then(() => {
        location.reload()
      })
    },
    async makepostData () {
      for (let post of this.postsData) {
        for (let data of post.mediaIds) {
          if (data.indexOf(this.mediasId[0]) !== -1 && post.mediaIds.length > 1) {
            this.postIdsArray = post.mediaIds.filter(item => {
              return item !== this.mediasId[0]
            })
            console.log(this.postIdsArray)
          } else if (data.indexOf(this.mediasId[0]) !== -1 && post.mediaIds.length === 1) {
            this.postIdsArray = []
          }
        }
        for (let data of post.mediaUrls) {
          if (data.indexOf(this.mediaSrc) !== -1 && post.mediaUrls.length > 1) {
            this.postUrlsArray = post.mediaUrls.filter(item => {
              return item !== this.mediaSrc
            })
            console.log(this.postUrlsArray)
          } else if (data.indexOf(this.mediaSrc) !== -1 && post.mediaUrls.length === 1) {
            this.postUrlsArray = []
          }
        }
        console.log(this.postId)
      }
      return true
    },
    async deleteData () {
      let flg = await this.makepostData()
      if (flg) {
        posts.doc(this.postId).update({
          mediaIds: this.postIdsArray,
          mediaUrls: this.postUrlsArray
        }).then(() => {
          medias.doc(this.mediasId[0]).delete().then(() => {
            console.log('Document successfully deleted!')
            let path = ''
            if (this.isMovie) {
              path = `movies/${this.uid}/${this.fileName}`
            } else {
              path = `images/${this.uid}/${this.fileName}`
            }
            const desertRef = storage.ref().child(path)
            // Firebase Storageに保存されている画像削除
            desertRef.delete().then(() => {
              location.reload()
            }).catch((error) => {
              console.log(error)
              location.reload()
            })
          }).catch((error) => {
            console.error('Error removing document: ', error)
          })
        })
      }
      console.log(flg)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

video, img {
  width: 320px
}
</style>



// WEBPACK FOOTER //
// src/components/check.vue